// @flow

export const FETCH_SEARCH_NOTIFICATIONS = 'WEB_PUSH/FETCH_SEARCH_NOTIFICATIONS';
export const SET_SEARCH_NOTIFICATIONS = 'WEB_PUSH/SET_SEARCH_NOTIFICATIONS';
export const UPDATE_SEARCH_NOTIFICATION = 'WEB_PUSH/UPDATE_SEARCH_NOTIFICATION';
export const UPDATE_SEARCH_NOTIFICATION_SUCCESS = 'WEB_PUSH/UPDATE_SEARCH_NOTIFICATION_SUCCESS';
export const RESTORE_SEARCH_NOTIFICATIONS = 'WEB_PUSH/RESTORE_SEARCH_NOTIFICATIONS';



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/SearchNotifications/actionTypes.js